import { IZFIcon } from "../../component";

const zfIcon = "zf-icon-react--";

const getIconClass = (iconName, isActive?: boolean) => {
	let zfIconClass = zfIcon;

	if (isActive) {
		zfIconClass += "active--";
	}
	return zfIconClass + iconName;
};

const ZFIcon = (props: IZFIcon) => {
	const { iconName, isActive, iconClasses } = props;

	const iconClassAll: Array<string> = [];

	const iconPreDefinedClass = getIconClass(iconName, isActive);
	iconClassAll.push("zf-icon-react", iconPreDefinedClass);

	if (iconClasses) {
		iconClassAll.push(...iconClasses);
	}

	const fIconClass = iconClassAll.filter(Boolean).join(" ");

	return <i className={fIconClass}></i>;
}

export default ZFIcon;
